import React, { useState } from 'react'
import { Alert, Button, Form, Input, Typography } from 'antd'
import { TCallList } from '../../../../context/types'
import SchedulerAvailabilityViewer from '../../../helpers/SchedulerAvailabilityViewer/SchedulerAvailabilityViewer'
import { CronofyCallbackNotificationSlot } from 'cronofy-elements'
import SpinLoader from '../../../helpers/SpinLoader'
import { useCallsListContext } from '../../../../context/call/CallsListProvider'

const { TextArea } = Input
const { Text, Title } = Typography

function Reschedule({ call, onCancel }: { call: TCallList; onCancel: () => void }) {
	const { callsList, actions } = useCallsListContext()
	const [form] = Form.useForm()
	const [startTimeError, setStartTimeError] = useState<string | null>(null)

	const onFinish = async (values: { change_reason: string; start_time: string }) => {
		if (!values.start_time) {
			setStartTimeError('Please choose a new date!')
		} else {
			await actions.reschedule({
				...values,
				id: call.id,
			})
			onCancel()
		}
	}

	return (
		<SpinLoader loading={!!callsList.loading}>
			<Form name="RescheduleForm" form={form} onFinish={onFinish} scrollToFirstError layout="vertical">
				<Title level={3}>Reschedule</Title>
				<Form.Item
					label="Reschedule Reasons"
					name="change_reason"
					rules={[{ required: true, message: 'Please explain in detail your reschedule reasons!' }]}
				>
					<TextArea
						placeholder="Please explain in detail your reschedule reasons."
						autoSize={{ minRows: 4, maxRows: 8 }}
					/>
				</Form.Item>
				<Form.Item noStyle name="start_time">
					<Input style={{ visibility: 'hidden' }} />
				</Form.Item>
				{callsList.error && (
					<Alert showIcon message="Error" description={callsList.error} type="error" style={{ marginTop: 20 }} />
				)}
			</Form>
			<div>
				<SchedulerAvailabilityViewer
					cronofy_account_id={call?.expert_cronofy_account_id}
					onAction={(slot: CronofyCallbackNotificationSlot) => {
						setStartTimeError(null)
						form.setFieldsValue({
							...form.getFieldsValue(),
							start_time: slot.start,
						})
					}}
				/>
				<Text type="danger">{startTimeError}</Text>
			</div>
			<div className="btn-actions" style={{ marginTop: '20px' }}>
				<Button shape="round" type="primary" onClick={() => form.submit()} disabled={!!callsList.loading}>
					Update
				</Button>
				<Button shape="round" disabled={!!callsList.loading} onClick={onCancel}>
					Cancel
				</Button>
			</div>
		</SpinLoader>
	)
}

export default Reschedule
